<!-- src/LoginPage.vue -->
<template>
  <div class="login-container">
    <form @submit.prevent="handleSubmit" class="login-form">
      <img src="/assets/logoMirindraa.PNG" alt="logo" class="logo" />
      <h2 class="login-title">Location Mirindra</h2>
      <label for="email" class="login-label">Entrez votre email</label>
      <InputComponent 
        id="email" 
        placeholder="Email" 
        v-model="email" 
        class="login-input"
      />

      <label for="password" class="login-label">Entrez votre mot de passe</label>
      <InputComponent 
        id="password" 
        placeholder="Mot de passe" 
        type="password" 
        v-model="password" 
        class="login-input"
      />

      <ButtonComponent 
        label="Se connecter" 
        :onPressed="handleSubmit" 
        class="login-button"
      />
    </form>

    <div v-if="message" :class="{'success-message': isSuccess, 'error-message': !isSuccess}">
      {{ message }}
    </div>
    <div class="admin-link">
      <!-- <p>Vous êtes administrateur ? <router-link to="/loginAdmin">Connexion Admin</router-link></p> -->
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import InputComponent from './components/Input.vue';
import ButtonComponent from './components/ButtonComponent.vue';
import './assets/styleLogin.css';

// Données réactives
const email = ref('');
const password = ref('');
const message = ref('');
const isSuccess = ref(false);
const router = useRouter();

// Fonction de soumission du formulaire
async function handleSubmit() {
  console.log('Données envoyées:', { email: email.value, password: password.value });

  try {
    const API_URL = process.env.VUE_APP_API_URL;
    const response = await axios.post(`${API_URL}/api/user/login`, {
      email: email.value,
      password: password.value
    });

    const token = response.data.access_token;
    const user = response.data.user; // L'objet user doit contenir l'ID, le nom, etc.
    
    // Stockage des données dans le localStorage
    localStorage.setItem('token', token);
    localStorage.setItem('email', user.email);
    localStorage.setItem('user_id', user.id); // Stocke l'ID de l'utilisateur
    localStorage.setItem('userName', user.nom); // Stocke l'ID de l'utilisateur

    message.value = 'Connexion réussie !';
    isSuccess.value = true;

    // Redirige vers la page d'accueil
    router.push('/tableauDeBord');
  } catch (error) {
    if (error.response && error.response.status === 401) {
      message.value = 'Identifiants invalides. Veuillez réessayer.';
    } else {
      message.value = 'Erreur lors de la connexion : ' + (error.response ? error.response.data.message : error.message);
    }
    isSuccess.value = false;
    console.error('Erreur lors de la connexion:', error.response ? error.response.data : error.message);
  }
}
</script>

<style>
/* Vous pouvez ajouter vos styles ici */
</style>
